<template>
    <div>
        <div class="left-content wrap1" :class="{transit1:transit}">
            <div class="wrap-content1" :class="{'content-variation1':contentShow}">
                <parkGlance />
                <weatherMonitor :deviceList="list" />
            </div>
        </div>

        <div class="right-content wrap2" :class="{transit2:transit}">
            <div class="wrap-content2" :class="{'content-variation2':contentShow}">
                <yugeYanxue />
                <deviceWarning />
            </div>
        </div>

        <img src="@/assets/images/mb/mb_left.png" class="mb mb_left " :class="{'l_mb_position':transit}" alt="">
        <img src="@/assets/images/mb/mb_right.png" class="mb mb_right" :class="{'r_mb_position':transit}" alt="">

    </div>
</template>
<script>
import {equipList} from "@/api/lsyn2.js"

import parkGlance from '@/views/components/parkOverview/parkGlance.vue'
import weatherMonitor from '@/views/components/dataMonitoring/weatherMonitor.vue'
import yugeYanxue from '@/views/components/parkOverview/yugeYanxue.vue'
import deviceWarning from "@/views/components/parkOverview/deviceWarning.vue" 
export default {
  name: '',
  components:{parkGlance,weatherMonitor,yugeYanxue,deviceWarning},
  data () {
    return {
        transit:false,
        contentShow:false,
        weatherList:[],
        airList:[],
        list:[],
    }
  },
  created () {
    this.getEquipList()
  },
  destroyed(){
        clearTimeout(this.timer);
  },
  mounted () {
    let that=this
    this.timer=setTimeout(res=>{
        that.transit=true
        that.contentShow=true
    },200)
  },
  methods: {
    // 获取设备列表
    getEquipList(){
        let para = {
            pageNum:1,
            pageSize:1000,
            // customerId:1420,
        }
        equipList(para).then(res=>{
            if(res.code == 200){
                // console.log(res,"qiiiiiiiiiiiqiiiiiiiiiiiii")
                res.data.list.forEach(val=>{
                    // if(val.typeName == '气象监测'){
                    if(val.productId=='118'){
                        this.weatherList.push(val)
                    }else if(val.productId=='116'|| val.productId=='146'){  // 空气质量
                        this.airList.push(val)
                    }    
                })
                this.list=[...this.weatherList,...this.airList]
            }
        })
    },
  },
}
</script>
<style lang="less" scoped>
    .mb{
        width: 554px ;
        height: 1080px ;
        position: absolute;
        top: 0 ;
        z-index: 1;
        padding: 0 ;
    }
    .mb_left{
        left: -554px;
        transition: all 0.8s;
    }
    .mb_right{
        right: -554px;
        transition: all 0.8s;
    }

    .l_mb_position{
        left: 0px;
    }

    .r_mb_position{
        right: 0px;
    }

.left-content{
    width: 510px;
    height: 959px;
    background: url("~@/assets/images/content_bg.png");
    background-size: 100% 100%;
    background-position-x: -16px;
    background-position-y: -16px;
    padding: 10px 42px 10px 10px;
    box-sizing: border-box;
    z-index: 22;
}
.right-content{
    width: 510px;
    height: 959px;
    background: url("~@/assets/images/content_bg.png");
    background-size: 100% 100%;
    background-position-x: 16px;
    background-position-y: -16px;
    padding: 10px 16px 16px 48px;
    box-sizing: border-box;
    z-index: 5000;
}
</style>
